import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useGetOne } from 'react-admin';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { Currency } from 'types/embedded/currency';
import {
  RefundChargebackReportSummaryMerchantAccount,
  RefundChargebackReportSummaryMerchantAccountConversionValues,
  RefundChargebackReportSummaryMerchantAccountOriginalValues,
} from 'types/embedded/refundChargebackReport';
import { convertReactAdminIdToHydraId, formatCurrency } from 'utils';

type Props = {
  conversionValueKey: keyof RefundChargebackReportSummaryMerchantAccountConversionValues;
  originalValueKey: keyof RefundChargebackReportSummaryMerchantAccountOriginalValues;
  currency: any;
  source?:
    | keyof RefundChargebackReportSummaryMerchantAccountConversionValues
    | keyof RefundChargebackReportSummaryMerchantAccountOriginalValues;
} & Omit<FunctionFieldProps, 'render'>;

export const RefundChargebackReportSummaryAmountField: React.FC<Props> = ({
  label,
  conversionValueKey,
  originalValueKey,
  currency,
  source,
  ...rest
}) => {
  const { data: conversionCurrency } = useGetOne<Currency>(
    Resources.Currencies,
    {
      id: convertReactAdminIdToHydraId(currency, Resources.Currencies),
    },
    { enabled: !!currency },
  );

  return (
    <FunctionField
      label={label}
      render={(record: RefundChargebackReportSummaryMerchantAccount) => {
        if (Number(record?.[originalValueKey]) === 0) {
          return EMPTY_FIELD;
        }
        const isOriginalCurrency = record?.currency.alphaCode === conversionCurrency?.alphaCode;

        return (
          <Stack direction="column">
            <Typography variant="body2">
              {formatCurrency(Number(record?.[originalValueKey]))}{' '}
              <Typography component="span" fontWeight={500} variant="body2">
                {record?.currency.alphaCode}
              </Typography>
            </Typography>
            {!isOriginalCurrency && (
              <Typography color="#00000099" variant="body2">
                {formatCurrency(Number(record?.[conversionValueKey]))}{' '}
                <Typography component="span" fontWeight={500} variant="body2">
                  {conversionCurrency?.alphaCode}
                </Typography>
              </Typography>
            )}
          </Stack>
        );
      }}
      source={source}
      {...rest}
    />
  );
};
